module.exports = __webpack_public_path__ + "static/media/boobs_s.3b72db75.jpg";